import { Frame, Page, Layout, LegacyCard, Text, DataTable, Spinner } from '@shopify/polaris';
import { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import api from '../../helpers/api';
import Paginator from "../../components/Paginator";

const CustomerRefunds = () => {
    const { customerId } = useParams();
    const [refunds, setRefunds] = useState([]);
    const [loading, setLoading] = useState(true);
    const history = useHistory();
    const [meta, setMeta] = useState({current_page: 1, last_page: 1});

    useEffect(() => {
        loadRefunds();
    }, []);

    const loadRefunds = async (page = 1) => {
        if (customerId) {
            api.getCustomerRefunds(customerId, page).then((response) => {
                setRefunds(response.data.data);
                setMeta(response.data.meta);
            }).finally(() => {
                setLoading(false);
            });
        } else {
            api.getAllRefunds(page).then((response) => {
                setRefunds(response.data.data);
                setMeta(response.data.meta);
            }).finally(() => {
                setLoading(false);
            });
        }
    };

    const rows = refunds.map(refund => customerId ? [
        refund.id,
        `$${parseFloat(refund.value).toFixed(2)}`,
        refund?.shopify_user?.name,
        refund?.gift_card?.code ? `****${refund?.gift_card?.code}` : '',
        new Date(refund.created_at).toLocaleString(),
        <button className="Polaris-Button" onClick={() => { history.push(`/refunds/${refund.id}`) }}>Details</button>
    ] : [
        refund.id,
        `$${parseFloat(refund.value).toFixed(2)}`,
        refund?.shopify_user?.name,
        refund?.customer?.full_name ?? '',
        refund?.gift_card?.code ? `****${refund?.gift_card?.code}` : '',
        new Date(refund.created_at).toLocaleString(),
        <button className="Polaris-Button" onClick={() => { history.push(`/refunds/${refund.id}`) }}>Details</button>
    ]);

    return (
        <Frame>
            <Page title="Customer Refunds" backAction={{ content: 'Customer', onAction: () => { customerId ? history.push(`/customers/${customerId}`) : history.push(`/customers`)} }}>
                <Layout>
                    <Layout.Section>
                        {loading ? (
                            <LegacyCard sectioned>
                                <Text variant="bodyMd" color="subdued" alignment="center">
                                    <Spinner size="large" accessibilityLabel="Loading refunds" />
                                </Text>
                            </LegacyCard>
                        ) : refunds.length > 0 ? (
                            <>
                                <LegacyCard title="Refunds List" sectioned>
                                    <DataTable
                                        columnContentTypes={["numeric", "text", "text", "text", "text"]}
                                        headings={customerId ? ["ID", "Value", "Employee", "Gift Card (Last 4)", "Date Created", "Actions"] : ["ID", "Value", "Employee", "Customer", "Gift Card (Last 4)", "Date Created", "Actions"]}
                                        rows={rows}
                                    />
                                </LegacyCard>
                                <Paginator currentPage={meta.current_page} lastPage={meta.last_page} show={true} callback={(page) => loadRefunds(page)} />
                            </>
                        ) : (
                            <LegacyCard title="Refunds List" sectioned>
                                <Text variant="bodyMd">No refunds found for this customer.</Text>
                            </LegacyCard>
                        )}
                    </Layout.Section>
                </Layout>
            </Page>
        </Frame>
    );
};

export default CustomerRefunds;
